export default __webpack_public_path__ + "static/media/13-DonutTree.03c2f9d5.png";